import type { AddressBookLocationFilter } from "~/shared/components/address-book-modal/hooks/use-address-book-data.ts";
import type { AddressBookItemSummary } from "~/shared/schemas/address-book-schema.ts";
import type {
	QuoteStateType,
	SubGroupKey,
} from "~/shared/types/quote-details-types.ts";

/**
 * Builds the location filter passed to the (now decoupled) AddressBookModal from
 * the quote state, falling back to the currently selected address book item —
 * mirroring the logic that previously lived inside `useAddressBookData`.
 */
export const buildAddressBookLocationFilter = (
	quoteState: QuoteStateType,
	name: SubGroupKey,
	selectedAddressBookItem?: AddressBookItemSummary | null,
): AddressBookLocationFilter | undefined => {
	const locationData =
		name === "pickup"
			? quoteState.pickupPostalCode
			: quoteState.deliveryPostalCode;

	if (locationData?.postalCode && locationData.city) {
		return {
			postalCode: locationData.postalCode,
			city: locationData.city.name,
			state: locationData.city.state.abbreviation,
			country: locationData.city.state.countryCode,
		};
	}

	if (selectedAddressBookItem?.postalCode && selectedAddressBookItem.city) {
		return {
			postalCode: selectedAddressBookItem.postalCode,
			city: selectedAddressBookItem.city,
			state: selectedAddressBookItem.stateProvince ?? "",
			country: selectedAddressBookItem.country ?? "",
		};
	}

	return undefined;
};
